// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /config/traducoes/lista.
 *
 * `pagina` empty means "the whole database", which upstream can only answer
 * with three multi-megabyte reads — always name a page when you can.
 * `idioma` narrows `traducoes` to that language plus the default one.
 */
import { registerContract } from './validate'

export interface Traducoes_ListaInput {
pagina?: string
idioma?: string
q?: string
faltantes?: string
limite?: number
offset?: number
}

registerContract('Traducoes_ListaInput', {
  pagina:    { type: 'string',  required: false },
  idioma:    { type: 'string',  required: false },
  q:         { type: 'string',  required: false },
  faltantes: { type: 'string',  required: false },
  limite:    { type: 'number',  required: false },
  offset:    { type: 'number',  required: false },
})
